import MicrosoftAppSettings from './MicrosoftAppSettings'
import {
  deleteMicrosoftSsoConnection,
  getMicrosoftSsoStatus,
  saveMicrosoftSsoConnection,
} from '../service/microsoft'

export default function MicrosoftSsoSettings() {
  return (
    <MicrosoftAppSettings
      config={{
        titleKey: 'microsoftSsoSettingsTitle',
        hintKey: 'microsoftSsoSettingsHint',
        clientIdLabelKey: 'microsoftSsoClientId',
        tenantIdLabelKey: 'microsoftSsoTenantId',
        clientSecretLabelKey: 'microsoftSsoClientSecret',
        redirectUriLabelKey: 'microsoftSsoRedirectUri',
        connectedKey: 'microsoftSsoConnected',
        notConnectedKey: 'microsoftSsoNotConnected',
        saveKey: 'microsoftSsoSave',
        disconnectKey: 'microsoftSsoDisconnect',
        allFieldsRequiredKey: 'microsoftSsoAllFieldsRequired',
        savedMessageKey: 'microsoftSsoConnectionSaved',
        idPrefix: 'microsoft-sso',
        tenantIdRequired: true,
        guide: {
          href: '/DATASecurityKYC-MicrosoftAnmeldung(SSO).docx',
          labelKey: 'microsoftSsoGuide',
        },
        loadStatus: getMicrosoftSsoStatus,
        saveConnection: saveMicrosoftSsoConnection,
        deleteConnection: deleteMicrosoftSsoConnection,
      }}
    />
  )
}
